import { createContext, useContext } from "react";
import type { Competition } from "../../lib/queries/competitions";
import { liveAccessNotice } from "../../lib/competitionState";
import { ROLE_LABEL } from "../../lib/i18n/roles";

// Whether the competition shell was entered by somebody who may only read
// it (the competitions_viewer, auth/queries `readsCompetitionOnly`). Set
// once by CompetitionLayout; a page folds it into its `frozen` gate, which
// already switches off every write for a Dokončeno competition. Outside the
// shell (a page under test) it reads false.
export const CompetitionReadOnlyContext = createContext(false);

export function useCompetitionReadOnly(): boolean {
  return useContext(CompetitionReadOnlyContext);
}

export const READ_ONLY_COMPETITION_NOTICE =
  `Máte roli ${ROLE_LABEL.competitions_viewer}: soutěž vidíte celou, ale nic na ní neměníte.`;

/** The sentence a page shows when its writes are off: the reader's reason
 * first (it holds on every competition), else the competition's own. */
export function lockedNotice(
  c: Pick<Competition, "status" | "run_elsewhere"> | undefined,
  readOnly: boolean,
): string | null {
  // liveAccessNotice covers a frozen competition and one the hall runs.
  return readOnly ? READ_ONLY_COMPETITION_NOTICE : liveAccessNotice(c);
}
